import React, { useEffect } from "react";
import Sign from "./../images/sign.png";
import moment from "moment";
import { parse } from "path-browserify";
function formatDate(date) {
  const day = date.getDate();
  const monthIndex = date.getMonth();
  const year = date.getFullYear();

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const formattedDate = `${months[monthIndex]} ${day}, ${year}`;
  return formattedDate;
}
const today = new Date();
function ProvisionalOfferLetter(props) {
  const datediff = () => {
    const timeDiff = new Date(props?.data?.valid) - today;
    return Math.floor(timeDiff / (1000 * 60 * 60 * 24));
  };
  return (
    <div
      className="container"
      style={{
        fontFamily: "Arial, Helvetica, sans-serif",
        fontSize: "16px",
        lineHeight: "1.35",
        color: "#333",
      }}
    >
      <div className="p-[2%] mb-[2%] rounded-[3px] shadow-[0_0_5px_2px_#aaafb3] bg-white">
        <p>{formatDate(today)}</p>
        <br />
        <div className="d-flex justify-content-between">
          <p>
            <span
              style={{
                fontWeight: "bold",
                fontSize: !props?.data?.roll ? "15px" : "14.3px",
              }}
            >
              {props?.data?.Gender
                ? props.data.Gender.toLowerCase().includes("male")
                  ? "Mr. "
                  : "Ms. "
                : ""}
              {props?.data?.Name},
            </span>
            <br />
            {props?.data?.roll && (
              <>
                Reg No: {props?.data?.roll}
                <br />
              </>
            )}
            Email Id: {props?.data?.mail} <br />
            {props?.data?.collegeName && (
              <>College Name: {props.data.collegeName}</>
            )}
          </p>
        </div>
        <br />
        <p>
          Dear{" "}
          {props?.data?.Gender
            ? props.data.Gender.toLowerCase().includes("male")
              ? "Mr. "
              : "Ms. "
            : ""}
          {props.data.Name},
        </p>
        <br />
        <p>Subject: Provisional Offer of Employment</p>
        <br />
        <p
          style={{
            fontSize: !props?.data?.roll ? "15px" : "14.3px",
            fontWeight: "bold",
          }}
        >
          Congratulations and Welcome Onboard!{" "}
        </p>
        <br />

        <p>
          We are happy to offer you the position of Graduate Trainee for the
          first 6 months. On successful completion of the traineeship, you will
          be confirmed as {props.data.designation} at a commensurate Cost to the
          Company (with a regular pay scale). Our Traineeship is performance
          driven and competitive. If you exhibit a fast-learning curve and the
          ability to take ownership, the period of traineeship can be reduced
          accordingly.
        </p>
        <br />

        <p>
          Your date of joining would be{" "}
          <i
            style={{
              fontWeight: "bold",
              fontSize: !props?.data?.roll ? "15px" : "14.3px",
            }}
          >
            {formatDate(new Date(props.data.doj))}
          </i>
          . You will be expected to join our office at
        </p>
        <br />
        <p
          style={{
            fontWeight: "bold",
            textDecoration: "italic",
          }}
        >
          <i>
            Block B6, 1st floor, Gateway office parks,
            <br />
            No 16 GST road, Perungalathur, <br />
            Gateway office parks, Chennai - 600063
          </i>
        </p>
        <br />

        <p>
          This letter can be treated as the provisional offer from Data-Aces.
          You will be provided with a hard copy of the offer letter upon
          joining.
        </p>
        <br />

        <p
          style={{
            fontWeight: "bold",
            fontSize: !props?.data?.roll ? "15px" : "14.3px",
            // marginBottom: "15px",
          }}
        >
          Terms of Offer:{" "}
        </p>
        <br />
        <p>
          During the graduate traineeship, you will be paid a fixed sum of INR{" "}
          {props.data?.CTC ? props.data.CTC : 15000}/- per month for 6 months.
          Traineeship Pay and Tenure are likely to be revised based on your
          performance evaluation which will be done regularly by the leadership.
        </p>
        <br />
        <p>
          On successful completion of the traineeship, you will be confirmed on
          remuneration of INR 4,00,000/- per annum, which will include company
          contribution towards retirals (PF and Gratuity). In addition, you may
          be paid a performance bonus of INR 1,00,000/- on completion of 12
          months of services from the date of confirmation.
        </p>
        <br />
        <p style={{ marginTop: "30px" }}>
          On signing upon this Provisional Offer of Employment, you agree to
          extend your service for two years from the date of commencement of
          your Graduate traineeship. The company reserves the right to demand a
          compensation for the training costs incurred if the mandatory service
          period is not honoured by you.
        </p>
        <br />
        <p
          style={{
            fontWeight: "bold",
            fontSize: !props?.data?.roll ? "15px" : "14.3px",
          }}
        >
          Acceptance of Offer:{" "}
        </p>
        <br />
        <p>
          Kindly confirm your acceptance of the offer by email within the next
          03 days.
        </p>
        <br />
        <p>
          Do not hesitate to call me if you require more information from our
          side.{" "}
        </p>
        <br />
        <p>
          I would like to welcome you once again to be a part of our family!
        </p>
        <br />
        <p>All the best for a fruitful and exciting career with us!</p>
        <br />
        <p>With warm regards,</p>

        <img src={Sign} style={{ height: "80px" }} />
        <div className="d-flex justify-content-between">
          <div>
            <p style={{ marginBottom: "0px" }}>Venkata Rangarajan</p>
            <p style={{ marginTop: "0px" }}>
              Director & Head of India Operations
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProvisionalOfferLetter;
